import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/main/Home";
import Navigate from "./components/Navigate";
import Experiments from "./pages/experiments/experiments";
import Experiment from "./pages/experiment/experiment";
import Footer from "./components/Footer";
import { Teams } from "./pages/main/Teams";
import { AboutUs } from "./pages/main/AboutUs";
import { ContactUs } from "./pages/main/ContactUs";
import Simulation from "./pages/simulation/simulation";
import Test from "./pages/test/test";
function App() {
  return (
    <div className="App">
      <Navigate />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/experiments" element={<Experiments />} />
        <Route path="/team" element={<Teams />} />
        <Route path="/experiments/:id" element={<Experiment />} />
        <Route path="/experiments/:id/test" element={<Test />} />
        <Route path="/experiments/:id/simulation" element={<Simulation />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
